import { motion } from "framer-motion";
import { Search, Pencil, Layout, Users, Code, Rocket } from "lucide-react";

export const DesignProcess = () => {
  const steps = [
    {
      icon: Search,
      title: "Discovery & Research",
      description: "Understanding your users, business goals, and market landscape"
    },
    {
      icon: Users,
      title: "User Journey Mapping",
      description: "Creating detailed user flows and interaction patterns"
    },
    {
      icon: Pencil,
      title: "Wireframing",
      description: "Building the structural foundation of your digital product"
    },
    {
      icon: Layout,
      title: "UI Design",
      description: "Crafting beautiful, intuitive interfaces that delight users"
    },
    {
      icon: Code,
      title: "Prototyping",
      description: "Creating interactive prototypes for testing and validation"
    },
    {
      icon: Rocket,
      title: "Implementation",
      description: "Bringing designs to life with pixel-perfect development"
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-blue-50 to-white">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-16">
          <motion.h2 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-4xl font-bold text-blue-900 mb-4"
          >
            Our Design Process
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="text-xl text-blue-600 max-w-3xl mx-auto"
          >
            A systematic approach to creating exceptional digital experiences
          </motion.p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {steps.map((step, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              whileHover={{ scale: 1.02 }}
              className="p-6 rounded-xl bg-white shadow-lg border border-blue-100 group hover:bg-gradient-to-br hover:from-blue-50 hover:to-white transition-all duration-300"
            >
              <div className="mb-6 w-14 h-14 rounded-full bg-blue-100 flex items-center justify-center group-hover:bg-blue-200 transition-colors">
                <step.icon className="h-8 w-8 text-blue-600" />
              </div>
              <h3 className="text-xl font-semibold mb-3 text-blue-900">{step.title}</h3>
              <p className="text-blue-600">{step.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};